module.exports = __webpack_public_path__ + "img/igud-large.a73b9a1d.svg";